import { render, staticRenderFns } from "./marketing-pad.vue?vue&type=template&id=1b45633e&scoped=true"
import script from "./marketing-pad.vue?vue&type=script&lang=js"
export * from "./marketing-pad.vue?vue&type=script&lang=js"
import style0 from "./marketing-pad.vue?vue&type=style&index=0&id=1b45633e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b45633e",
  null
  
)

export default component.exports